import { render, staticRenderFns } from "./newApproval.vue?vue&type=template&id=13e0348a&scoped=true"
import script from "./newApproval.vue?vue&type=script&lang=js"
export * from "./newApproval.vue?vue&type=script&lang=js"
import style0 from "./newApproval.vue?vue&type=style&index=0&id=13e0348a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e0348a",
  null
  
)

export default component.exports